import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import CaseCards from '../modules/views/CaseCards';
import { CARDS_REFORM } from '../Const';
import PageMeta from '../modules/components/PageMeta';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        title="リフォームの施工事例"
        description="飯田建築のリフォーム施工事例。キッチン・浴室・洗面などの水回りから、屋根・外壁塗装、内窓設置まで。施工前後の写真でご紹介します。"
        path="/case/reform"
      />
      <NavBar />
      <CaseCards
        title={'リフォーム'}
        eyebrow="Reform"
        cards={CARDS_REFORM}
        animation={'animate__animated animate__fadeInUp'}
        backHref="/case"
      />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
